import { styled } from 'next-yak';

import {
  mediaConfinedOnly,
  mediaConfinedNavlessOnly,
} from '@xing-com/layout-tokens';
import {
  scale110,
  scale060,
  spaceL,
  spaceM,
  spaceS,
  spaceXS,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const BenefitCopy = styled(BodyCopy)`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaConfinedOnly}, ${mediaConfinedNavlessOnly} {
    && {
      font-size: ${scale060};
    }
  }
`;

export const BenefitsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceL};

  & ul,
  li {
    margin: 0;
    padding: 0;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spaceM};
  list-style: none;
`;

export const ListItem = styled.li`
  display: flex;
  gap: ${spaceS};
  align-items: center;

  & > p {
    margin: 0;
  }

  & svg {
    flex-shrink: 0;
    min-height: ${scale110};
    min-width: ${scale110};
  }
`;

export const HeadlineContainer = styled.div`
  display: flex;
  gap: ${spaceS};
  padding-bottom: ${spaceXS};
`;
